module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\">\n<path d=\"M63,24H40V1c0-0.6-0.4-1-1-1H25c-0.6,0-1,0.4-1,1v23H1c-0.6,0-1,0.4-1,1v14c0,0.6,0.4,1,1,1h23v23c0,0.6,0.4,1,1,1h14\n\tc0.6,0,1-0.4,1-1V40h23c0.6,0,1-0.4,1-1V25C64,24.4,63.6,24,63,24z\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/icons/actions/add.svg
// module id = 1393
// module chunks = 0